import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { Conditions } from '../../rules/Conditions';
import { P2GText } from '@parcel2go/core-ui';
import { getItemValuesForCondition } from './getItemValuesForCondition';
import { toConditionDisplayName } from './toConditionDisplayName';
import { TariffCode } from '../../../customs/TariffCode';

interface props {
  condition: string;
  item: SmartSendItemApiModel;
}

export default function CreateRuleOptionLabel(props: props) {
  return props.condition === Conditions.Item_TariffCode ? (
    <>
      <P2GText variant="body2">{toConditionDisplayName(props.condition)}?</P2GText>
      <TariffCode code={getItemValuesForCondition(props.item, props.condition)[0]} selectable={false} />
    </>
  ) : (
    <P2GText variant="body2">
      {toConditionDisplayName(props.condition)}?
      <br />
      <P2GText variant="body2" small>
        (<strong>{getItemValuesForCondition(props.item, props.condition).join(' or ')}</strong>)
      </P2GText>
    </P2GText>
  );
}
